import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TractorsHectaresPerTractorWidgetComponent } from './tractors-hectares-per-tractor-widget.component';
import {DxChartModule} from 'devextreme-angular';



@NgModule({
  declarations: [TractorsHectaresPerTractorWidgetComponent],
    imports: [
        CommonModule,
        DxChartModule
    ],
  exports: [TractorsHectaresPerTractorWidgetComponent]
})
export class TractorsHectaresPerTractorWidgetModule { }
